module.exports = {"test":"123"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/translation.json
// module id = 3150
// module chunks = 0